import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for the /market-reports segment. Renders nothing of its own — it
// exists so the /market-reports index, /market-reports/$slug detail, and
// /market-reports/feed.xml routes share a parent. Per-page SEO lives in those
// child routes.
export const Route = createFileRoute("/market-reports")({
  component: Outlet,
});
